module.exports = __webpack_public_path__ + "media/images/icons/country_flags/nf-61dbabecc855f2087f76a3fbc8dd08ea.svg";